"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Button_1 = __importDefault(require("../Button"));
const locale_1 = require("date-fns/locale");
const date_fns_1 = require("date-fns");
const YearlyCalendar_1 = __importDefault(require("../Calendar/YearlyCalendar"));
const Calendar_1 = __importDefault(require("./Calendar"));
function ModalDatepicker({ onCancel, onSubmit, withYear, min, max, date: defaultDate, isInline, }) {
    const [date, setSelectedDate] = (0, react_1.useState)(defaultDate ? new Date(defaultDate) : new Date());
    const isDisabled = (0, react_1.useCallback)((date) => {
        // console.log(date, min || new Date(), max || new Date());
        if (min) {
            min.setHours(0);
            min.setUTCMinutes(0);
            min.setSeconds(0);
            date.setHours(0);
            date.setUTCMinutes(0);
            date.setSeconds(1);
            if ((0, date_fns_1.compareAsc)(date, min) <= 0) {
                return true;
            }
        }
        if (max) {
            max.setHours(23);
            max.setUTCMinutes(59);
            max.setSeconds(59);
            date.setHours(0);
            date.setUTCMinutes(0);
            date.setSeconds(0);
            if ((0, date_fns_1.compareAsc)(date, max) >= 0) {
                return true;
            }
        }
        return false;
    }, []);
    const onChange = (0, react_1.useCallback)((date) => {
        if (isDisabled(date))
            return;
        setSelectedDate(date);
    }, [isDisabled]);
    if (isInline)
        return ((0, jsx_runtime_1.jsx)("div", { className: "border dark:border-gray-700 pt-3", children: (0, jsx_runtime_1.jsx)(Calendar_1.default, { date: date, max: max, min: min, onSubmit: onSubmit, onChange: onChange, isDisabled: isDisabled }) }));
    if (withYear)
        return ((0, jsx_runtime_1.jsxs)("div", { className: "bg-white dark:bg-gray-900 dark:text-gray-200 shadow-xxs rounded-md p-4 flex flex-col min-w-[312px]", children: [(0, jsx_runtime_1.jsx)("div", { className: "flex justify-between mt-1", children: (0, jsx_runtime_1.jsx)("h6", { className: "text-xl", children: "Pilih Tanggal" }) }), (0, jsx_runtime_1.jsx)("hr", { className: "my-4 dark:border-gray-700" }), (0, jsx_runtime_1.jsx)(YearlyCalendar_1.default, { date: date, min: min, max: max, setSelectedDate: onChange, locale: locale_1.id }), (0, jsx_runtime_1.jsx)("hr", { className: "my-4" }), (0, jsx_runtime_1.jsxs)("div", { className: "flex gap-x-4", children: [(0, jsx_runtime_1.jsx)(Button_1.default, { ripple: true, state: "tertiary", color: "stale", className: "w-full justify-center", children: (0, jsx_runtime_1.jsx)("button", { onClick: onCancel, type: "button", children: "Batal" }) }), (0, jsx_runtime_1.jsx)(Button_1.default, { ripple: true, state: "secondary", className: "w-full justify-center", children: (0, jsx_runtime_1.jsx)("button", { onClick: () => onSubmit && onSubmit(date), type: "button", children: "Pilih" }) })] })] }));
    return ((0, jsx_runtime_1.jsxs)("div", { className: "bg-white dark:bg-gray-900 dark:text-gray-200 shadow-xxs rounded-md py-4 flex flex-col min-w-[312px]", children: [(0, jsx_runtime_1.jsx)(Calendar_1.default, { date: date, max: max, min: min, onChange: onChange, isDisabled: isDisabled }), (0, jsx_runtime_1.jsx)("hr", { className: "my-4 dark:border-gray-700" }), (0, jsx_runtime_1.jsxs)("div", { className: "flex gap-x-4 px-4", children: [(0, jsx_runtime_1.jsx)(Button_1.default, { ripple: true, state: "tertiary", color: "stale", className: "w-full justify-center", children: (0, jsx_runtime_1.jsx)("button", { onClick: onCancel, type: "button", children: "Batal" }) }), (0, jsx_runtime_1.jsx)(Button_1.default, { ripple: true, state: "secondary", className: "w-full justify-center", children: (0, jsx_runtime_1.jsx)("button", { onClick: () => onSubmit && onSubmit(date), type: "button", children: "Pilih" }) })] })] }));
}
exports.default = ModalDatepicker;
